<script>
import ExportIcon from "@/icons/ExportIcon.vue";
import apiClient from "@/api/api-client";

export default {
  name: "VerifiersReportsList",
  components: { ExportIcon },
  data() {
    return {
      reportType: "verifier",
      verifiersDate: null,
      verifiersList: [],
      loading: false,
    };
  },
  computed: {
    domain() {
      return window.domain;
    },
  },
  created() {
    this.getVerifiers();
  },
  methods: {
    toggleReport(type) {
      if (this.reportType !== type) {
        this.reportType = type;
        this.getVerifiers();
      }
    },
    changeVerifiersFilter() {
      this.getVerifiers();
    },
    async getVerifiers() {
      this.loading = true;
      try {
        let params = {};
        if (this.verifiersDate && this.verifiersDate.length > 0) {
          params.start_date = this.verifiersDate[0];
          params.stop_date = this.verifiersDate[1];
        }
        const url =
          this.reportType === "verifier"
            ? "/export/verifier"
            : "/export/verifier/all";
        const response = await apiClient.get(url, {
          params,
        });
        if (response && response.data) {
          this.verifiersList = response.data.data || [];
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async downloadReport(endpoint, params = {}) {
      this.loading = true;
      try {
        const data = await apiClient.post(endpoint, params);

        if (data && data.data && data.data.output_path) {
          const fileUrl = `${this.domain}${data.data.output_path}`;
          this.downloadFile(data.data.file_name, fileUrl);
        } else {
          alert("Не успешно");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    downloadFile(filename, fileUrl) {
      fetch(fileUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async downloadVerifiersReport() {
      const params =
        this.verifiersDate && this.verifiersDate[0] && this.verifiersDate[1]
          ? {
              start_date: this.verifiersDate[0],
              stop_date: this.verifiersDate[1],
            }
          : {};
      const url =
        this.reportType === "verifier"
          ? "/export/verifier"
          : "/export/verifier/all";
      await this.downloadReport(url, params);
    },
  },
};
</script>

<template>
  <div class="mng-page flex flex-col h-full w-full">
    <div class="mng-page__header flex-shrink-0">
      <div class="mng-page__title-row">
        <div class="seg-toggle inline-flex">
          <button
            class="seg-toggle__btn"
            :class="{ 'seg-toggle__btn--active': reportType === 'verifier' }"
            @click="toggleReport('verifier')"
          >
            Верификаторы
          </button>

          <button
            class="seg-toggle__btn"
            :class="{ 'seg-toggle__btn--active': reportType === 'all' }"
            @click="toggleReport('all')"
          >
            Все отчёты
          </button>
        </div>
      </div>
      <div class="mng-page__filters">
        <div class="flex flex-wrap items-center justify-end gap-3">
          <el-date-picker
            v-model="verifiersDate"
            value-format="YYYY-MM-DD"
            type="daterange"
            placeholder="Дата"
            style="max-width: 200px; margin-right: 10px"
            @change="changeVerifiersFilter"
          ></el-date-picker>
          <el-button
            @click="downloadVerifiersReport"
            :disabled="loading"
            type="success"
            plain
            class="download_button"
          >
            <export-icon></export-icon>
            Скачать xlsx</el-button
          >
        </div>
      </div>
    </div>
    <main
      class="mng-page__body flex-1 min-h-0 flex flex-col overflow-hidden"
      style="padding: 20px 26px"
    >
      <el-table
        :data="verifiersList"
        v-loading="loading"
        border
        stripe
        height="100%"
        style="width: 100%; overflow-y: auto"
      >
        <el-table-column
          type="index"
          label="№"
          width="70"
          align="center"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="display_name"
          label="Верификатор"
          min-width="240"
        ></el-table-column>
        <el-table-column
          prop="count"
          label="Верифицировано файлов"
          width="240"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="total_duration"
          label="Верифицировано часов"
          width="240"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="total_spent"
          label="Затрачено часов"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="rtf"
          label="RTF"
          width="150"
          align="center"
        ></el-table-column>
      </el-table>
    </main>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/manage-page.scss";
</style>
